import {matricesByGameId} from '../constants/enumsByGames'
import {gameConfigurationStore} from '../gameModule/store/gameConfigurationStore';
import {gameModuleStore} from '../gameModule/store/gameModuleStore';

export const handleSymbolAnimationPositionInMatrix = (winsMatrix) => {
    const winLines = [];
    let winLine = {};
    const {WinningLinesCoordinate, allLineMatrix, symbolsMatrix} = matricesByGameId[gameConfigurationStore.gameId]
    const allLinesMatrix = JSON.parse(JSON.stringify(allLineMatrix))
    winsMatrix.forEach((el) => {
        const activeSymbolsMatrix = JSON.parse(JSON.stringify(symbolsMatrix))
        let winElCount = 0;
        const lineIndex = el.line - 1;
        if (el.line) {
            for (let i = 0; i < gameConfigurationStore.reelsParams.length; i += 1) {
                const line = WinningLinesCoordinate[lineIndex][i];
                const row = line.x;
                const coll = line.y;
                if (winElCount < el.count) {
                    winElCount += 1;
                    activeSymbolsMatrix[row][coll] = 1;
                    allLinesMatrix[row][coll] = 1;
                } else {
                    activeSymbolsMatrix[row][coll] = 2;
                    allLinesMatrix[row][coll] = allLinesMatrix[row][coll] ? allLinesMatrix[row][coll] : 2;
                }
            }
        } else {
            gameModuleStore.resultMatrix.forEach((row, rowIndex) => {
                row.forEach((element, elementIndex) => {
                    if (element === el.symbol) {
                        if (winElCount < el.count) winElCount += 1;
                        activeSymbolsMatrix[elementIndex][rowIndex] = 1;
                        allLinesMatrix[elementIndex][rowIndex] = 1;
                    }
                });
            });
        }
        winLine = {
            line: el.line,
            count: el.count,
            winCard: el.symbol,
            // Табло ядра рисует иконку символа линии по `symbol` (winAmountPart/winLine).
            symbol: el.symbol,
            win: el.lineWinAmount,
            allLines: allLinesMatrix,
            lines: activeSymbolsMatrix,
        };
        winLines.push(winLine);
    });
    return {winLines, allLinesMatrix};
};
